import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MappingServicesService {

  constructor(public datepipe: DatePipe) { }

  getOtherReferencesList(trackingResponse, list) {
    if (trackingResponse.parcel.parcelNumberAVPI) {
      this.addEventInList(list, "Référence de l'avis de passage", "", trackingResponse.parcel.parcelNumberAVPI);
    }
    if (trackingResponse.parcel.parcelNumberInstance) {
      this.addEventInList(list, "Référence de l'avis d'instance", "", trackingResponse.parcel.parcelNumberInstance);
    }
    if (trackingResponse.parcel.infoInter) {
      if (trackingResponse.parcel.infoInter.partnerReference) {
        this.addEventInList(list, "Référence du Partenaire", "", trackingResponse.parcel.infoInter.partnerReference);
      }
    }
    return list;
  }

  getDetailsSteps(trackingResponse, list) {
    trackingResponse.parcel.event.forEach(element => {
      const oneEvent = {
        label: element.labelLong,
        date:   this.datepipe.transform(element.date, ' dd/MM/yyyy à HH:mm', '+0000').toString(), //Selon Franck LARRIVIERE, le WS renvoie l'horaire de la timezone FR il ne faut donc pas ajouter de timezone
        location: element.siteName,
        zipCode: element.siteZipCode,
        group: element.groupe
      }
      list.push(oneEvent);
    });
    return list;
  }

  getAlerts(trackingResponse, list) {
    trackingResponse.message.forEach(element => {
      const oneEvent = {
        title: element.type,
        image: "assets/images/picto_warning.svg",
        text: element.message
      }
      list.push(oneEvent);
    });
    return list;
  }

  private addEventInList(list, label, icon, value) {
    const oneEvent = {
      label: label,
      icon: (icon != "") ? icon : "assets/images/picto_livraison_simple.svg",
      value: value
    }
    list.push(oneEvent);
  }
}
